import { render, staticRenderFns } from "./company_tabbars.vue?vue&type=template&id=2100f142&scoped=true&"
import script from "./company_tabbars.vue?vue&type=script&lang=js&"
export * from "./company_tabbars.vue?vue&type=script&lang=js&"
import style0 from "./company_tabbars.vue?vue&type=style&index=0&id=2100f142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100f142",
  null
  
)

export default component.exports